import { Warning } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { Colors, PrimaryLink, Text } from 'library';
import { IJobPaymentError } from 'models';
import React from 'react';

interface IJobPaymentErrorDisplayProps {
    paymentError: IJobPaymentError;
}

export default function JobPaymentErrorDisplay({ paymentError }: IJobPaymentErrorDisplayProps) {
    return (
        <Grid
            style={{
                padding: 20,
                backgroundColor: Colors.errorBackground,
                borderRadius: 10,
                border: `1px solid ${Colors.error}`,
            }}
        >
            <Grid style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <Warning style={{ color: Colors.error, fontSize: 20 }} />
                <Text variant="body1" textStyle={{ color: Colors.error }} bold>
                    Action Required: Payment Issue
                </Text>
            </Grid>
            <Text variant="body2" textStyle={{ marginBottom: 16 }}>
                {paymentError.message}
            </Text>
            {paymentError.link && paymentError.link.path ? (
                <PrimaryLink style={{ backgroundColor: Colors.error }} to={paymentError.link.path}>
                    {paymentError.link.text}
                </PrimaryLink>
            ) : null}
        </Grid>
    );
}
